import React, { Component, useState, useEffect } from 'react';
import {connect} from 'react-redux';

import { Typography, Grid, Box, Container } from '@material-ui/core';

import TitleText from './components/TitleText';
import KontenText from './components/KontenText';
import Garis from './components/Garis';
import RenderChart from './components/RenderChart';

import Footer from './components/Footer';
import './styleDinas.css';

class DinasJatim_2 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    componentDidMount(){
    }
    

    render() { 

        return (
            <Grid 
                spacing={3}
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                >                 

                {/* GRAFIK ATAS */}
                <Grid item xs={12}>
                    <Grid container spacing={5} style={{marginLeft: -90}}>
                        <Grid item xs={5}>
                            <RenderChart />
                        </Grid>
                        <Grid item xs={7} style={{alignSelf: 'center'}}>
                            <table width="100%">
                                <tr>
                                    <td width="8%"> <div className="lingkaran-kecil main-bg-lvlmudah"></div> </td>
                                    <td>
                                        <KontenText title={'KATEGORI MUDAH'} subTitle={'15,35 % atau 59.388 siswa, soal dalam kategori Mudah.'} />
                                    </td>
                                </tr>
                                <tr>
                                    <td width="8%"> <div className="lingkaran-kecil main-bg-lvlsedang"></div> </td>
                                    <td>
                                        <KontenText title={'KATEGORI SEDANG'} subTitle={'19,55 % atau 75.638 siswa, soal dalam kategori Sedang.'} />
                                    </td>
                                </tr>
                                <tr>
                                    <td width="8%"> <div className="lingkaran-kecil main-bg-lvlsulit"></div> </td>
                                    <td>
                                        <KontenText title={'KATEGORI SULIT'} subTitle={'65,1% atau 251.869 Siswa, soal dalam kategori Sulit.'} />
                                    </td>
                                </tr>
                            </table>
                        </Grid>

                    </Grid>
                </Grid>  

                {/* MAPEL POT || DAR */}
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={1}>&nbsp;</Grid>

                        <Grid item xs={4}>
                            <TitleText title="MATA PELAJARAN POTENSI" subTitle="*Mata pelajaran potensi adalah mata pelajaran yang rata-rata nilai pada kabupaten >= 70" />
                            <Box mt={3}>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" color="textSecondary" component="i">Biologi</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <KontenText title="42.15 %" subTitle="" />
                                    </Grid>
                                    
                                </Grid>
                            </Box>
                        </Grid>

                        <Grid item xs={1} style={{textAlign: '-webkit-center'}}>
                            <div style={{background: '#A19882', height: '125%', width: 2}}>&nbsp;</div>
                        </Grid>

                        <Grid item xs={4}>
                            <TitleText title="MATA PELAJARAN DARURAT" subTitle="*Mata pelajaran darurat adalah mata pelajaran yang rata-rata nilai pada kabupaten <= 50" />
                            <Box mt={3}>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <Typography variant="body1" color="textSecondary" component="i">Fisika</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <KontenText title="70.36 %" subTitle="" />
                                    </Grid>
                                    
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Grid>


                <Grid item xs={12}>
                    <div className="text-background main-bg-color">informasi hasil pemetaan learning style</div>
                    <Garis/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container style={{placeContent: 'center'}}>
                        <Grid item xs={3}>
                            <Grid container>
                                <Grid item>
                                    <img src="/image/dinas/icon-visual.jpg" style={{width: 65, height: 65}} className="img-title"/>
                                </Grid>
                                <Grid item>
                                    <TitleText title={'42 %'} subTitle={'171.048 Siswa'} />
                                    <Typography variant="body1" style={{fontWeight: 700, color: '#1E3163'}}>VISUAL</Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={3}>
                            <Grid container>
                                <Grid item>
                                    <img src="/image/dinas/icon-auditori.jpg" style={{width: 65, height: 65}} className="img-title"/>
                                </Grid>
                                <Grid item>
                                    <TitleText title={'42 %'} subTitle={'171.048 Siswa'} />
                                    <Typography variant="body1" style={{fontWeight: 700, color: '#1E3163'}}>AUDITORI</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        
                        <Grid item xs={3}>
                            <Grid container>
                                <Grid item>
                                    <img src="/image/dinas/icon-kinestetik.jpg" style={{width: 65, height: 65}} className="img-title"/>
                                </Grid>
                                <Grid item>
                                    <TitleText title={'42 %'} subTitle={'171.048 Siswa'} />
                                    <Typography variant="body1" style={{fontWeight: 700, color: '#1E3163'}}>KINESTETIK</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>


                <Grid item xs={12}>
                    <div className="text-background main-bg-color">informasi hasil pemetaan psychology test</div>
                    <Garis/>
                </Grid>

                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={2}>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <div className="lingkaran-kecil main-bg-lvlmudah"></div>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" color="textSecondary">Rata-rata Bawah</Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <div className="lingkaran-kecil main-bg-lvlsedang"></div>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" color="textSecondary">Rata-rata</Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item>
                                    <div className="lingkaran-kecil main-bg-lvlsulit"></div>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body2" color="textSecondary">Rata-rata Atas</Typography>
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item  xs={3} style={{textAlign: 'center'}}>
                            <div className="kiri-print">
                                <RenderChart />
                            </div>
                            <Typography variant="body1" color="textPrimary" style={{fontWeight: 700}}>ADVERSITY QUOTIENT</Typography>
                        </Grid>

                        <Grid item xs={3} style={{textAlign: 'center'}}>
                            <div className="kiri-print">
                                <RenderChart />
                            </div>
                            <Typography variant="body1" color="textPrimary" style={{fontWeight: 700}}>EMOTIONAL QUOTIENT</Typography>
                        </Grid>

                        <Grid item xs={3} style={{textAlign: 'center'}}>
                            <div className="kiri-print">
                                <RenderChart />
                            </div>
                            <Typography variant="body1" color="textPrimary" style={{fontWeight: 700}}>ACHIEVEMENT MOTIVATION</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <div class="component-footer"><Footer halaman={2}/></div>
            </Grid>

        );
    }

}

export default DinasJatim_2;